//27-12-2024 - User details added - Subha
import React, { useEffect } from "react";
import AliianceManagerLayout from "../../../components/layouts/AliianceManagerLayout";
import AdminPageContainer from "../../../components/AdminPageContainer";
import { useNavigate } from "react-router";
import { useQuery } from "react-query";
import AllianceManagerServices from "../../../services/API/AllianceManager";
import { useState } from "react";
import { toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import Loader from "../../../components/Loader";
import Pagination from "react-js-pagination";
import { Link, useParams } from "react-router-dom";
import moment from "moment";

const UserDetails = () => {
  const vendor = {
    type: "active",
  };
  const navigate = useNavigate();
  const limit = 20;
  const [page, setPage] = useState(1);
  const [dataToShow, setDataToShow] = useState([]);
  const [loading, setIsLoading] = useState(false);
  const [card, setCard] = useState();
  const [allLicenseRequests, setAllLicenseRequests] = useState();
  let { user_id } = useParams();
  
  useEffect(() => {
    fetchAllLicenseRequests();
  }, [user_id]);

  const fetchAllLicenseRequests = async () => {
    setIsLoading(true);
    try {
      const res = await AllianceManagerServices.getAllLicenseRequests({
        page,
        limit,
        user_id
      });
      if (res?.status == "success") {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        setAllLicenseRequests(res?.data);
        setDataToShow(res?.data?.data);
        setIsLoading(false);
      } else {
        setAllLicenseRequests({});
        setDataToShow([]);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <AliianceManagerLayout vendor="active">
      <AdminPageContainer>
        <div id="main" role="main">
          <div id="content">
            <div>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={"/alliance-manager/dashboard"}>Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={"/alliance-manager/user-lists"}>User Lists</Link>
                </li>
                <li className="breadcrumb-item active">User Details</li>
              </ol>
            </div>
            <div className="card card-sm card-shadow mb-3">
              <div className="card-body">
                <div className="d-flex justify-content-between">
                  <h2>User Details </h2>
                </div>

                <div className="max-w-100 overflow-auto">
                  <div className="table-responsive">

                  <table
                  className="table-bordered table-hover dataTable no-footer"
                  id="myTable1"
                  style={{
                    minWidth: "100%",
                  }}
                >
                  <thead>
                    <tr
                      role="row"
                      style={{
                        fontWeight: "500",
                        background: "#eee",
                      }}
                    >
                      <th
                        className="text-center align-top py-2 td-sr"
                        tabIndex="0"
                        aria-controls="myTable1"
                        rowSpan="1"
                        colSpan="1"
                        aria-sort="ascending"
                        aria-label="SR No.: activate to sort column ascending"
                        style={{ width: "4%" }}
                      >
                        S. No.
                      </th>
                      <th
                        className="text-center align-top py-2"
                        tabIndex="0"
                        aria-controls="myTable1"
                        rowSpan="1"
                        colSpan="1"
                        aria-sort="ascending"
                        aria-label="SR No.: activate to sort column ascending"
                        style={{ width: "9%" }}
                      >
                        SRN
                      </th>

                      <th
                        className=" text-center align-top py-2"
                        tabIndex="0"
                        aria-controls="myTable1"
                        rowSpan="1"
                        colSpan="1"
                        aria-label="Type of Request: activate to sort column ascending"
                        style={{ width: "8%" }}
                      >
                        Type of Request
                      </th>
                      <th
                        className="text-center align-top py-2"
                        tabIndex="0"
                        aria-controls="myTable1"
                        rowSpan="1"
                        colSpan="1"
                        aria-label="Location: activate to sort column ascending"
                        style={{ width: "8%" }}
                      >
                        Location
                      </th>
                      <th
                        className="text-center align-top py-2"
                        tabIndex="0"
                        aria-controls="myTable1"
                        rowSpan="1"
                        colSpan="1"
                        aria-label="License Type: activate to sort column ascending"
                      >
                        License
                      </th>
                      <th
                        className="text-center align-top py-2"
                        tabindex="0"
                        aria-controls="myTable1"
                        rowspan="1"
                        colspan="1"
                        aria-label="License Type: activate to sort column ascending"
                      >
                        Executive
                      </th>
                      <th
                        className="text-center align-top py-2"
                        tabindex="0"
                        aria-controls="myTable1"
                        rowspan="1"
                        colspan="1"
                        aria-label="Field Executive: activate to sort column ascending"
                      >
                        Field Executive
                      </th>
                      <th
                        className="text-center align-top py-2"
                        tabIndex="0"
                        aria-controls="myTable1"
                        rowSpan="1"
                        colSpan="1"
                        aria-label="Due Date: activate to sort column ascending"
                        style={{ width: "10%" }}
                      >
                        Due Date
                      </th>
                      <th
                        className="text-center align-top py-2"
                        tabIndex="0"
                        aria-controls="myTable1"
                        rowSpan="1"
                        colSpan="1"
                        aria-label="Requested Date: activate to sort column ascending"
                        style={{ width: "10%" }}
                      >
                        Requested Date
                      </th>
                      <th
                        className="text-center align-top py-2"
                        tabIndex="0"
                        aria-controls="myTable1"
                        rowSpan="1"
                        colSpan="1"
                        aria-label="Requested By: activate to sort column ascending"
                        style={{ width: "10%" }}
                      >
                        Requested By
                      </th>
                      <th
                        className="text-center align-top py-2"
                        tabIndex="0"
                        aria-controls="myTable1"
                        rowSpan="1"
                        colSpan="1"
                        aria-label="Status: activate to sort column ascending"
                      >
                        Status
                      </th>
                      <th
                        className="text-center align-top py-2"
                        tabIndex="0"
                        aria-controls="myTable1"
                        rowSpan="1"
                        colSpan="1"
                        aria-label="Status: activate to sort column ascending"
                        style={{ width: "9%" }}
                      >
                        Sub Status
                      </th>
                      <th
                        className="text-center align-top py-2"
                        // className="sorting"
                        tabIndex="0"
                        aria-controls="myTable1"
                        rowSpan="1"
                        colSpan="1"
                        aria-label="Status: activate to sort column ascending"
                      >
                        Vendor
                      </th>
                    </tr>
                  </thead>

                  <tbody style={{ fontSize: "12px" }}>
                    {dataToShow?.length > 0 &&
                      dataToShow.map((item, key) => (
                        <tr role="row" className="odd" key={key}>
                          <td className="text-start align-middle">
                            {allLicenseRequests?.from + key}
                          </td>
                          <td className="sorting_1 text-start align-middle">
                            <Link
                              to={`/alliance-manager/overall-license-requests/license-request-details/${item.id}`}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                {item?.srn_fasttrack == "1" && (
                                  <i
                                    className="fa-solid fa-flag"
                                    style={{ color: "red" }}
                                  ></i>
                                )}

                                <span>{item?.srn_name || ""}</span>
                              </div>
                            </Link>
                          </td>

                          <td className="text-start align-middle">
                            {item?.license_type || ""}
                          </td>
                          <td className="text-start align-middle">
                            {item?.city_name || ""}, {item?.state_name || ""} -{" "}
                            {item?.pin_code || ""}
                          </td>

                          <td
                            className="text-start align-middle"
                            style={{ maxWidth: "30px" }}
                          >
                            {item?.license_name || ""}
                          </td>
                          <td
                            className="text-start align-middle"
                            style={{ maxWidth: "20px" }}
                          >
                            {item?.executive_name ? (
                              <>
                                <i
                                  class="fa-solid fa-user"
                                  style={{ color: "#c6538c" }}
                                ></i>{" "}
                                {item.executive_name}
                              </>
                            ) : (
                              ""
                            )}
                          </td>
                          <td style={{ maxWidth: "20px" }}>
                            {item?.field_executive_name ? (
                              <>
                                , <br />{" "}
                                <i
                                  class="fa-solid fa-user"
                                  style={{ color: "#c6538c" }}
                                ></i>{" "}
                                {item.field_executive_name}
                              </>
                            ) : (
                              ""
                            )}
                          </td>
                          <td className="text-start align-middle">
                            {item?.srn_duedate
                              ? moment(item?.srn_duedate).format(
                                  "DD-MM-YY hh:mm A"
                                )
                              : ""}
                          </td>
                          <td
                            className="text-start align-middle"
                          >
                            {" "}
                            {item?.srn_requesteddate
                              ? moment(item?.srn_requesteddate).format(
                                  "DD-MM-YY hh:mm A"
                                )
                              : ""}{" "}
                          </td>
                          <td className="text-start align-middle">
                            {" "}
                            {item?.requested_by || ""}{" "}
                          </td>
                          <td className="text-start align-middle">
                            {
                            card == "Copy Shared" ? "Copy Shared" : 
                            item?.srn_status ? item?.srn_status : 
                            ""
                            }
                          </td>
                          <td className="text-start align-middle">
                            {item?.srn_substatus || ""}
                          </td>
                          <td className="text-start align-middle">
                            {item?.vendor_name || ""}
                          </td>
                        </tr>
                      ))}
                    {!dataToShow?.length > 0 && !loading && (
                      <tr>
                        <td colSpan={12} className="text-center align-middle">
                          No data found
                        </td>
                      </tr>
                    )}
                    {loading ?  
                      <tr>
                        <td colSpan={12} className="text-center align-middle">
                          <Loader />
                        </td>
                      </tr>
                    : null }
                  </tbody>
                </table>
                  </div>
                </div>
                <div className="d-flex justify-content-end mr-2">
                {allLicenseRequests?.total > limit && (
                  <Pagination
                    activePage={allLicenseRequests?.current_page}
                    itemsCountPerPage={Number(allLicenseRequests?.per_page)}
                    totalItemsCount={allLicenseRequests?.total}
                    pageRangeDisplayed={5}
                    onChange={(number) => {
                      setPage(number);
                    }}
                  />
                )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </AdminPageContainer>
    </AliianceManagerLayout>
  );
};

export default UserDetails;
